export default function currency(value) {
  // https://github.com/superlanding/landing/issues/1610
  if (value === 'MYR') {
    return 'RM'
  }
  return value
}
